<template>
  <div class="main__content">
    <div class="table__header_bar">
      <InputSearch isFilter @detectSearchValue="searchTableHandler" />
      <Button
        isControl
        iconName="plus"
        class="add__adm_cont"
        @click.native="createDartUserHandler"
        >{{ $t('sections.access_admin_to_register') }}
      </Button>
    </div>
    <Table
      v-if="getTableOfAccessAccessAdmin.table"
      :content="getTableOfAccessAccessAdmin.table.items"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import Table from '@/elements/Table';
import { mapGetters } from 'vuex';

export default {
  components: {
    Table,
  },

  data() {
    return {};
  },

  created() {
    this.$store.dispatch('getTableOfAccessAccessAdmin');
  },

  computed: {
    ...mapGetters(['getTableOfAccessAccessAdmin']),
  },

  methods: {
    tableHandler() {
      this.$store.dispatch('getTableOfAccessAccessAdmin');
    },

    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('getTableOfAccessAccessAdmin');
    },

    createDartUserHandler() {
      this.$router.push({
        name: 'access-administrator_access-admin-create-user',
        params: { activity: 'create' },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.add__adm_cont
  width: 450px
  font-size: 16px
  @include s
    font-size: 14px
    width: auto
  @include xs
    font-size: 13px
    line-height: 16px
    text-align: center
</style>
